// extracted by mini-css-extract-plugin
export default {"containerLogin":"Login-module--containerLogin--0m361","absoluteContainer":"Login-module--absoluteContainer--lHPHs"};